import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Order from '@/repositories/data/webshop/Order';

export default class OrderRepository extends BaseCrudRepository<number, Order, Order> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/order/');
    }
}
